import ArrayHandler from './ArrayHandler';

export function useArrayHandler<
  ValueType extends { id: string },
  ChangeHandler extends (updatedValues: ValueType[]) => void
  >(values: ValueType[], onChange: ChangeHandler) {
  return new ArrayHandler(values, onChange);
}
